import {
  ICityResponsePayload,
  ICountryResponsePayload,
  IStateResponsePayload,
} from 'shared/interfaces/utils/ICountryStateApi';

export const mappedCountry = (countries: ICountryResponsePayload | undefined) => {
  return (countries || []).map((country) => {
    return {
      key: country.name,
      value: country.iso2,
    };
  });
};

export const getCountryCode = (countriesData: ICountryResponsePayload | undefined, country: String) => {
  return mappedCountry(countriesData || []).find((v) => v.key === country)?.value || '';
};

export const getCountry = (countriesData: ICountryResponsePayload | undefined, country_code: String) => {
  return mappedCountry(countriesData || []).find((v) => v.value === country_code)?.key || '';
};

export const mappedState = (states: IStateResponsePayload) => {
  return states.map((state) => {
    return {
      key: state.name,
      value: state.iso2,
    };
  });
};

export const mappedCity = (cities: ICityResponsePayload) => {
  return cities.map((city) => {
    return {
      key: city.name,
      value: city.name,
    };
  });
};
